import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState, QueryParameterState, addQueryParam, changeQueryParams } from 'src/api';
import { RouterState } from 'connected-react-router';
import { Icon } from '../../Images';

import './FolderSwitchView.scss';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './FolderSwitchView.messages';
import { userIsInternal } from '../../Admin/utils';
import NewButtons from './NewButtons';
import { Link, withRouter } from 'react-router-dom';

export interface FolderSwitchViewState {
}

export interface FolderSwitchViewProps {
  dispatch: any;
  configurations: GlobalPrivateState['configurations'];
  groups: GlobalPrivateState['groups'];
  location: RouterState['location'];
  params: QueryParameterState['params'];
  user: GlobalPrivateState['user'];
  backUrl?: string;
  folderId?: string;
  history: any;
}

export class FolderSwitchViewPartial extends React.Component<FolderSwitchViewProps, FolderSwitchViewState> {

  constructor(props: FolderSwitchViewProps) {
    super(props);
  }

  public render() {
    return (
      <div className={[
        "partial-folder-switch-view", 
        (this.props.configurations.updating || this.props.groups.updating) ? "updating" : ""
      ].join(' ')}>
        <a href="#" className="back" onClick={(event) => {
          event.preventDefault();
          const { history, backUrl } = this.props;
          if (history.length > 1) {
            history.goBack();
          } else {
            history.push('/');
          }
        }}>
          <Icon name="chevron-left" /><FormattedMessage {...MESSAGES.goBack} />
        </a>
        <NewButtons folderId={this.props.folderId} />
      </div>
    );
  }
}

export const FolderSwitchView = connect((state: GlobalPrivateState) => ({
  configurations: state.configurations,
  groups: state.groups,
  location: state.router.location,
  params: state.queryState.params,
  user: state.user,
}))(withRouter(FolderSwitchViewPartial as any) as any);

export default FolderSwitchView as any;
